export function imagesSlider() {
    const $slider = $(".images-slider-holder");
    $slider.find(".slide").attr("tabindex", "-1");
    $slider.each(function () {
        const slider = $(this).find('.images-slider');
        const sliderNav = $(this).find('.images-slider-nav');
        slider.slick({
            slidesToScroll: 1,
            slidesToShow: 1,
            fade: true,
            appendArrows: sliderNav
        })
    }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        const $slides = $(slick.$slides);
        $slides.find(".slide").attr("tabindex", "-1");
    }).on('afterChange', function (event, slick, currentSlide, nextSlide) {
        const $slides = $(slick.$slides);
        $slides.eq(currentSlide).find(".slide").attr("tabindex", "0").focus();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/imagesSlider.js